let geolocationID;

export default {
	cancelLocationWatch() {
		navigator.geolocation.clearWatch(geolocationID);
	},
	getLocation(callback) {
		geolocationID = navigator.geolocation.getCurrentPosition(
			(location) => callback({ location }),  callback({ error: true }), { enableHighAccuracy: true });
	},
}
